import {
  useCreateDocumentMutation,
  useCreateDocumentVersionMutation,
} from "@hooks";
import { Document, TEMPLATE_ID } from "@models";

/**
 * Upload a file as a document.
 * This is how TEMPLATE_ID.USER_UPLOAD documents are created.
 * @param orgId
 * @param deviceId
 */
export const useUserUploadTemplate = (orgId: string, deviceId: string) => {
  const createDocumentMutation = useCreateDocumentMutation();
  const createDocumentVersionMutation = useCreateDocumentVersionMutation(
    orgId,
    deviceId
  );

  const uploadFileAsDocument = async (
    file: File,
    document?: Document
  ): Promise<Document> => {
    if (!document) {
      document = await createDocumentMutation.mutateAsync({
        orgId,
        deviceId,
        templateKey: TEMPLATE_ID.USER_UPLOAD,
        title: file.name,
      });
    }

    const documentVersion = await createDocumentVersionMutation.mutateAsync({
      docId: document.id,
      file,
    });

    return {
      ...document,
      versions: [documentVersion],
    };
  };

  return { uploadFileAsDocument };
};
